import { useEffect, useState } from "react";
import type { PromotionDetailImage } from "../promotion-types";
import { Button } from "./ui";
import "./promotion-content.css";

function DetailImage({ item, index }: { item: PromotionDetailImage; index: number }) {
  const [failed, setFailed] = useState(false), [attempt, setAttempt] = useState(0);
  useEffect(() => { setFailed(false); setAttempt(0); }, [item.image]);
  return <figure className="promotion-content__figure" aria-label={`活动详情图 ${index + 1}`}>
    {failed ? <div className="promotion-content__unavailable" role="status"><p>第 {index + 1} 张活动图片暂时无法显示。</p><Button type="button" emphasis="outline" onClick={() => { setFailed(false); setAttempt(value => value + 1); }}>重新加载图片</Button></div>
      : <img key={attempt} src={item.image} alt={`活动详情图 ${index + 1}`} loading="lazy" decoding="async" onError={() => setFailed(true)} />}
    {item.caption && <figcaption>{item.caption}</figcaption>}
  </figure>;
}

/** Draft previews and published details share the original-image and plain-text renderer. */
export function PromotionContent({ content, images = [] }: { content?: string; images?: PromotionDetailImage[] }) {
  if (!content && !images.length) return null;
  return <div className="promotion-content">
    {content && <div className="promotion-content__text">{content}</div>}
    {images.map((item, index) => <DetailImage key={item.image} item={item} index={index} />)}
  </div>;
}
